import { makeStyles } from '@alpha/ui-lib/theme';

const useStyles = makeStyles(
  () => ({
    tableWrapper: {
      backgroundColor: 'white',
      borderRadius: '10px',
    },
    table: {
      padding: '0px 24px',
      '& .MuiTableCell-head': {
        color: '#949494',
      },
      '& .MuiTableCell-body': {
        padding: '10px 0px !important',
      },
      '& tr:last-child .MuiTableCell-root': {
        borderBottom: 'none !important',
      },
      '& .requires-action': {
        backgroundColor: '#FFF3E0',
        '& .MuiTableCell-body': {
          backgroundColor: '#FFF3E0',
        },
      },
    },
    searchInput: {
      width: '300px',
      '& .MuiInputLabel-root': {
        color: 'rgba(0, 0, 0, 0.4)',
      },
      '& .MuiInputBase-root': {
        height: '44px',
        '& .MuiBox-root': {
          backgroundColor: 'transparent',
        },
      },
      height: '44px',
    },
    paginationWrapper: {
      padding: '0px 24px',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: '60px',
    },
    emptyTable: {
      padding: '60px 0',
      fontWeight: 100,
      '& .image': {
        height: '120px',
        width: '120px',
        '& img': {
          height: '60px',
          width: '60px',
        },
      },
    },
  }),
  { name: 'RemittersTable' },
);

export default useStyles;
